const BLACKLIST_URL = `${process.env.PUBLIC_URL || ''}/blacklist.json`;

let blacklistCache = null;

function fetchBlacklist() {
    if (typeof window === 'undefined') {
        return { cnpjEmpresasMigradas: [] };
    }

    try {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', BLACKLIST_URL, false);
        xhr.send(null);

        if (xhr.status === 200) {
            const parsed = JSON.parse(xhr.responseText);
            return parsed || { cnpjEmpresasMigradas: [] };
        }
    } catch (error) {
        console.error('Erro ao carregar blacklist.json', error);
    }

    return { cnpjEmpresasMigradas: [] };
}

export function loadBlacklist() {
    if (!blacklistCache) {
        blacklistCache = fetchBlacklist();
    }

    return blacklistCache;
}

export function isBlacklisted(item) {
    const blacklist = loadBlacklist();
    return Array.isArray(blacklist?.cnpjEmpresasMigradas)
        ? blacklist.cnpjEmpresasMigradas.includes(item)
        : false;
}